import React from "react";
import Icon from "./Icon";
export default function Scissors() {
  return /*#__PURE__*/React.createElement(Icon, null, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.25C7.01878 8.25 8.25 7.01878 8.25 5.5C8.25 3.98122 7.01878 2.75 5.5 2.75C3.98122 2.75 2.75 3.98122 2.75 5.5C2.75 7.01878 3.98122 8.25 5.5 8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19.25C7.01878 19.25 8.25 18.0188 8.25 16.5C8.25 14.9812 7.01878 13.75 5.5 13.75C3.98122 13.75 2.75 14.9812 2.75 16.5C2.75 18.0188 3.98122 19.25 5.5 19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 3.66667L7.44336 14.5567"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2642 13.2733L18.3333 18.3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44336 7.44333L11 11"
  }));
}
Scissors.displayname = "Scissors";
//# sourceMappingURL=Scissors.js.map